<div class="input-group input-group-sm">
  <input [id]="getId(input)" [attr.type]="input.MainElementList[0].Type" class="col q-input-border q-bo" aria-label="Small" attr.aria-describedby="{{getId(input)}}-btn"
         [disabled]="isDisabled(input)"
         [(ngModel)]="input.MainElementList[0].Value"
         [ngClass]="setClass(input)">
  <div *ngFor="let button of input.MainElementList.slice(1)" class="input-group-append">
    <button *ngIf="button.Type === 'BUTTON'" class="q-btn q-bo q-main p-0" (click)="OnButtonClick(button, input?.MainElementList[0], ModalAgGrid);"
            [title]="button.Tooltip">
      <i class="{{button.Src}}"></i>
    </button>
  </div>
</div>



<ng-template #ModalAgGrid let-modalAgGrid>
  <div #header class="modal-header w-100">
    <h5 class="modal-title big-title" id="exampleModalLongTitle"></h5>

    <button type="button" class="close" aria-label="Close" (click)="modalAgGrid.close('CANCEL')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body overflow-auto" [style.height]="sanitizer.bypassSecurityTrustStyle('calc(80vh - ' + header.offsetHeight + 'px)')">
    <q-customgrid class='h-100 w-100'
                  [customgridParam]="customgridParam"
                  (cellClicked)="OnSelectionChanged($event, modalAgGrid)"
                  [customgridHeight]="'calc(80vh - ' + header.offsetHeight + 'px)'"
                  (gridReady)="onGridReady($event)"
                  #agGrid>
    </q-customgrid>
  </div>
</ng-template>

<!--#endregion Fin Modal envoie mail Personnalisés-->
